// extracted by mini-css-extract-plugin
export default {"external":"a28nZK","section":"b28nZK","text":"c28nZK","sectionLink":"d28nZK","link":"e28nZK","withIcons":"f28nZK"};